"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const ExtendedWorkFields = ({ fields, className }) => (react_1.default.createElement(react_1.default.Fragment, null, fields === null || fields === void 0 ? void 0 : fields.map((field) => {
    var _a;
    return (react_1.default.createElement("div", { className: className, key: field.title },
        field.tooltip ? (react_1.default.createElement(CustomToolTip_1.default, { key: field.title, title: field.title + ':', info: (_a = field.tooltip) !== null && _a !== void 0 ? _a : '' })) : (react_1.default.createElement("span", null,
            field.title,
            ":")),
        react_1.default.createElement("span", null, field.value)));
})));
exports.default = ExtendedWorkFields;
